import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {WheelNewsOrder, User} from '../../../models/models';
import {Translation} from '../../../models/translation';
import {LoginService} from '../../../services/login.service';
import {WheelNewsOrderService} from '../../../services/wheelNewsOrder.service';
import {CheckService} from '../../../services/check.service';
import {ColumnModel, GridComponent} from '@syncfusion/ej2-angular-grids';
import {MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import {DatePipe} from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-wheelnews-orderview',
  templateUrl: './wheelnews-orderview.component.html',
  styleUrls: ['./wheelnews-orderview.component.css'],
  providers: [DatePipe]
})
export class WheelnewsOrderviewComponent implements OnInit {
  @ViewChild('wheelNewsOrderGrid', {static: true}) private wheelNewsOrderGrid: GridComponent;
  @ViewChild('matDialog', {static: true}) matDialog: TemplateRef<MatDialog>;

  public translation: Translation;
  public options: ColumnModel[];
  public locale: string;
  public dataSource: WheelNewsOrder[] = [];
  public config: MatDialogConfig = {width: '80vw', height: '80%'};
  public wheelNewsOrder: WheelNewsOrder;

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private wheelNewsOrderService: WheelNewsOrderService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRight(7);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.loadDataForGrid();
  }

  async loadDataForGrid() {
    this.wheelNewsOrderService.getOrdersForWheelnewsOrderview(+sessionStorage.getItem('RightStatus'), JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid).subscribe(async response => {
      if (response.Ok) {
        this.dataSource = response.Obj;
        this.initGrid();
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { await this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  public initGrid() {
    this.wheelNewsOrderGrid.allowPaging = true;
    this.wheelNewsOrderGrid.pageSettings = {pageCount: 5, pageSize: 15};
    this.wheelNewsOrderGrid.toolbar = ['Search'];
    this.wheelNewsOrderGrid.editSettings = {allowEditing: true, allowAdding: false, allowDeleting: false, mode: 'Dialog'};
    this.options = [
      {
        field: 'Id',
        headerText: this.translation.Id,
        textAlign: 'Left',
        isPrimaryKey: true,
      },
      {
        field: 'OrderDate',
        headerText: this.translation.OrderDate,
        textAlign: 'Left',
        type: 'dateTime',
        format: 'dd.MM.yyyy HH:mm'
      },
      {
        field: 'RimsetList.0.CommissionNumber',
        headerText: this.translation.CommissionNumber,
        textAlign: 'Left'
      },
      {
        field: 'User',
        headerText: this.translation.CreatedBy,
        textAlign: 'Left'
      },
    ];
  }

  actionBegin(args) {
    if (args.requestType === 'beginEdit') {
      args.cancel = true;
      this.wheelNewsOrder = args.rowData;
      this.dialog.open(this.matDialog, this.config);
    }
  }

  cancel() {
    this.wheelNewsOrder = new WheelNewsOrder();
    this.dialog.closeAll();
  }

  generatePdf(orderId: number) {
    const orderIds = [];
    orderIds.push(orderId);
    this.wheelNewsOrderService.generatePdfByOrderIds(orderIds).subscribe(response => {
      if (response.Ok) {
        const binaryString = window.atob(response.Obj.toString());
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; ++i) { bytes[i] = binaryString.charCodeAt(i); }
        window.open(URL.createObjectURL(new Blob([bytes], {type: 'application/pdf'})), '_blank');
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }
}
